export enum MotionDirection {
  UNKNOWN = 'unknown',
  APPROACHING = 'approaching',
  RECEDING = 'receding',
  STATIC = 'static',
}
